import { isAndroid, isIOS, loadScript, parseCookie } from '../core/util';
const NET_MAP = {
  0: 'none',
  1: 'wifi',
  2: '2g',
  3: '3g',
  4: '4g',
};

const qqJsbLibUrl = '//pub.idqqimg.com/qqmobile/qqapi.wk.js?_bid=152&max_age=25930000';

function checkJSBridgeReady(JSBNS, callback) {
  if (JSBNS) {
    callback(JSBNS);
  } else if (window.mqq && window.mqq.invoke) {
    callback(window.mqq);
  } else {
    loadScript(qqJsbLibUrl).then(() => {
      callback(window.mqq);
    });
  }
}

export default function (JSBNS, callback) {
  checkJSBridgeReady(JSBNS, (JSBNS) => {
    // eslint-disable-next-line no-unused-vars
    const cookie = parseCookie(document.cookie);
    const params = {
      /* network_type: function() {
                return new Promise((resolve, reject) => {
                    JSBNS.device.getNetworkInfo(param => {
                        resolve(NET_MAP[param.type] || 'unknown');
                    });
                });
            }*/
    };
    if (isAndroid) {
      Object.assign(params, {
        deviceInfo: new Promise((resolve) => {
          JSBNS.device.getDeviceInfo((param) => {
            resolve({
              dataType: 'multi-field',
              dataList: [
                { field: 'imei', value: param.identifier },
                { field: 'imsi', value: param.imsi },
                { field: 'mac', value: param.macAddress },
                { field: 'android_id', value: param.androidID },
              ],
            });
          });
        }),
      });
    } else if (isIOS) {
      Object.assign(params, {
        network_type() {
          return new Promise((resolve) => {
            JSBNS.device.getNetworkInfo((param) => {
              resolve(NET_MAP[param && param.type] || 'unknown');
            });
          });
        },
        idfa: new Promise((resolve) => {
          const T = setTimeout(() => {
            console.log('beacon report qq idfa is empty');
            resolve('');
          }, 2000);

          JSBNS.device.getDeviceInfo((param) => {
            clearTimeout(T);
            resolve(param.idfa);
          });
        }),
        idfv: '',
      });
    }
    callback(params);
  });
}
